import { Subscription } from '@yandex-int/k-common';
import { SimpleCallback, SimpleText } from 'platform-components';
import React from 'react';

import { ConfirmationDialog } from 'common.components/confirmation-dialog/confirmation-dialog';

interface Props {
    opened: boolean;
    isLoading: boolean;
    subscription: Subscription;
    onClose: SimpleCallback;
    onSubscribe: SimpleCallback;
}

export const SubscriptionModal = (props: Props) => {
    const { opened, subscription, onClose, onSubscribe, isLoading } = props;

    return (
        <ConfirmationDialog
            cancelInProgress={isLoading}
            closable={true}
            confirmInProgress={isLoading}
            confirmLabelId="subscriptionModal.submit"
            headerId="subscriptionModal.title"
            headerType={SimpleText.TYPE.MARKDOWN}
            messageId={subscription.subscribe_text}
            messageType={SimpleText.TYPE.MARKDOWN}
            mix="subscription-modal"
            onClose={onClose}
            onConfirm={onSubscribe}
            onReject={onClose}
            opened={opened}
            rejectLabelId="courseView.overviewBanner.subscriptionModal.cancel"
        />
    );
};
